export default {
  getPerson: (state) => state.person,
};
